import React from 'react';
import { Type, Gauge, FileText, Music2 } from 'lucide-react';
import { Chip } from '../ui/Chip.js';
import type { TabEditKind } from '../../types/index.js';
import { TAB_EDIT_KIND_LABELS } from '../../utils/tabEdits.js';

export interface EditKindChipProps {
  kind: TabEditKind;
  variant?: 'display' | 'filter';
  selected?: boolean;
  onClick?: () => void;
  size?: 'sm' | 'md';
  className?: string;
  'data-testid'?: string;
  testId?: string;
}

export const EditKindChip: React.FC<EditKindChipProps> = ({
  kind,
  variant = 'display',
  selected = false,
  onClick,
  size,
  className = '',
  'data-testid': dataTestId,
  testId
}) => {
  const iconMap: Record<TabEditKind, React.ReactNode> = {
    DETAILS: <Type className="size-3.5 shrink-0" aria-hidden="true" />,
    DIFFICULTY: <Gauge className="size-3.5 shrink-0" aria-hidden="true" />,
    LYRICS: <FileText className="size-3.5 shrink-0" aria-hidden="true" />,
    SCORE: <Music2 className="size-3.5 shrink-0" aria-hidden="true" />
  };

  const label = TAB_EDIT_KIND_LABELS[kind] ?? kind;
  const chipSize = size ?? (variant === 'filter' ? 'md' : 'sm');
  const defaultTestId = variant === 'filter' ? `edits-filter-kind-${kind}` : `edit-kind-${kind}`;
  const testIdValue = dataTestId || testId || defaultTestId;

  return (
    <Chip
      variant={variant}
      size={chipSize}
      selected={selected}
      onClick={onClick}
      icon={iconMap[kind]}
      className={`text-xs ${className}`}
      data-testid={testIdValue}
    >
      {label}
    </Chip>
  );
};

EditKindChip.displayName = 'EditKindChip';
